import { useEffect } from 'react';
import { createPortal } from 'react-dom';

const Portal = ({ children, containerId = 'contact-form-portal' }) => {
  useEffect(() => {
    // Create container if it doesn't exist
    let container = document.getElementById(containerId);
    if (!container) {
      container = document.createElement('div');
      container.id = containerId;
      container.style.position = 'fixed';
      container.style.top = '0';
      container.style.left = '0';
      container.style.width = '100%';
      container.style.height = '100%';
      container.style.zIndex = '99999';
      container.style.pointerEvents = 'none';
      document.body.appendChild(container);
    }

    return () => {
      // Cleanup: remove container when component unmounts
      const containerToRemove = document.getElementById(containerId);
      if (containerToRemove && containerToRemove.childNodes.length === 0) {
        document.body.removeChild(containerToRemove);
      }
    };
  }, [containerId]);

  const container = document.getElementById(containerId);
  if (!container) return null;

  return createPortal(children, container);
};

export default Portal;

